import { render, staticRenderFns } from "./subject_cont.vue?vue&type=template&id=0c74aeeb&scoped=true"
import script from "./subject_cont.vue?vue&type=script&lang=js"
export * from "./subject_cont.vue?vue&type=script&lang=js"
import style0 from "./subject_cont.vue?vue&type=style&index=0&id=0c74aeeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74aeeb",
  null
  
)

export default component.exports